import { ApplicationConfig, ENVIRONMENT_INITIALIZER, inject } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { appInterceptor } from './shared/interceptor/app.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { auth0Interceptor } from './shared/interceptor/auth0.interceptor';
import { GlobalInputSecurityService } from './shared/services/global-input-security.service';
import { Auth0Service } from './auth/service/auth0.service';
import { initRefreshTokenChecker } from './auth/utils/token-polling.utils';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    // provideClientHydration(),
    provideAnimationsAsync(),

    provideHttpClient(withFetch(), withInterceptors([appInterceptor,auth0Interceptor])),
    provideToastr({
      positionClass: 'toast-top-right',
    }),
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () => {
        inject(GlobalInputSecurityService).init();
      },
    },
    // {
    //   provide: ENVIRONMENT_INITIALIZER,
    //   multi: true,
    //   useValue: () => {
    //     if (typeof window === 'undefined') {
    //       return;
    //     }

      
    //   },
    // },
   provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin + '/platform/callback',
        audience: `https://${environment.auth0.audience}/api/v2/`,
        scope: 'openid profile email offline_access'
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
    }),
  ],
};